import PropTypes from 'prop-types'
import React, { useEffect, useState } from "react"

import { Route, Routes, useLocation } from "react-router-dom"
import { connect } from "react-redux"
import { ToastContainer } from 'react-toastify'

// Import Routes all
import { userRoutes, authRoutes, superAdminRoutes } from "./routes/allRoutes"

// Import all middleware
import SuperAuthmiddleware from "./routes/middleware/AdminAuthmiddleware"

import Authmiddleware from "./routes/middleware/Authmiddleware"

// layouts Format
import VerticalLayout from "./components/VerticalLayout/"
import HorizontalLayout from "./components/HorizontalLayout/"
import NonAuthLayout from "./components/NonAuthLayout"

// Import scss
import "./assets/scss/theme.scss"

// Import CSS
import "./assets/css/global.css"

// Import Firebase Configuration file
// import { initFirebaseBackend } from "./helpers/firebase_helper"

import fakeBackend from "./helpers/AuthType/fakeBackend"
import { getUser } from "store/users/actions";
import { useDispatch } from 'react-redux'
import axiosInstance from 'components/Common/ApiManagement/axiosInstance';
import { ApiNames } from 'components/Common/ApiManagement/apiServices';
import { handleErrors } from 'components/Common/common';

// Activating fake backend
fakeBackend()

// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_APIKEY,
//   authDomain: process.env.REACT_APP_AUTHDOMAIN,
//   databaseURL: process.env.REACT_APP_DATABASEURL,
//   projectId: process.env.REACT_APP_PROJECTID,
//   storageBucket: process.env.REACT_APP_STORAGEBUCKET,
//   messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
//   appId: process.env.REACT_APP_APPID,
//   measurementId: process.env.REACT_APP_MEASUREMENTID,
// }

// init firebase backend
// initFirebaseBackend(firebaseConfig)

const App = props => {
  const [loading, setLoading] = useState(true);

  function getLayout() {
    let layoutCls = VerticalLayout
    switch (props.layout.layoutType) {
      case "horizontal":
        layoutCls = HorizontalLayout
        break
      default:
        layoutCls = VerticalLayout
        break
    }
    return layoutCls
  }
  
  const Layout = getLayout()
  const path = useLocation()

  const dispatch = useDispatch()

  useEffect(() => {
    if (!path.pathname.includes('login') && !path.pathname.includes('activation') && !path.pathname.includes('resetPassword')){     
      axiosInstance.post(ApiNames.USER_AUTH, {})
        .then(res => {
          dispatch(getUser(res.data.data))
          setLoading(false)
        }).catch(err => {
          dispatch(getUser({}))
          setLoading(false)
          handleErrors(err)
        })
    }
    else{

      setLoading(false)
    }
  }, [dispatch])

  if (loading) return null

  return (
    <React.Fragment>
      <ToastContainer />
      <Routes>
        {/* Non-authenticated routes */}
        {authRoutes.map((route, idx) => (
          <Route
            key={idx}
            path={route.path}
            element={
              <NonAuthLayout>
                {route.component}
              </NonAuthLayout>
            }
          />
        ))}

        {/* Authenticated routes */}
        {userRoutes.map((route, idx) => (
          <Route
            key={idx}
            path={route.path}
            element={
              <Authmiddleware>
                <Layout>{route.component}</Layout>
              </Authmiddleware>
            }
          />
        ))}

        {superAdminRoutes.map((route, idx) => (
          <Route
            key={idx}
            path={route.path}
            element={
              <SuperAuthmiddleware>
                <Layout>{route.component}</Layout>
              </SuperAuthmiddleware>
            }
          />
        ))}
      </Routes>
    </React.Fragment>
  )
}

App.propTypes = {
  layout: PropTypes.any
}

const mapStateToProps = state => {
  return {
    layout: state.Layout,
  }
}

export default connect(mapStateToProps, null)(App)
